module.exports = __webpack_public_path__ + "img/mc360-sm.e967999a.svg";